<div class="promotion-dialog">
  <h2 class="promotion-title">Activar {{ moduleName }}</h2>

  <p class="promotion-line">Incluido gratis durante la promoción.</p>
  <p class="promotion-price">Después: 15 €/mes</p>
  <p class="promotion-note">Sin compromiso. Te avisaremos antes de cualquier cobro.</p>

  <div class="promotion-actions">
    <button type="button" class="btn-ok" *ngIf="!isConfirm" (click)="close()">{{ actionLabel }}</button>
    <button type="button" class="btn-ok" *ngIf="isConfirm" (click)="confirm()">{{ actionLabel }}</button>
  </div>
</div>
